var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconToastSuccess = function SvgIconToastSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#EEF9E8",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#429D15",
    fillRule: "evenodd",
    d: "M24.642 9.955c.74.74.74 1.939 0 2.679l-9.472 9.472c-.74.74-1.94.74-2.68 0L7.756 17.37a1.894 1.894 0 0 1 2.679-2.68l3.396 3.397 8.132-8.132c.74-.74 1.94-.74 2.68 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconToastSuccess;